import styled, { css, useTheme } from 'styled-components';
import { Tooltip } from '@elfsight/widget-modal';
import { IconButton, type IconButtonProps } from '@elfsight/widget-ui';

type HeaderButtonProps = Omit<IconButtonProps, 'color' | 'backgroundColor'> & {
  tooltipTitle: string;
  disableBackground?: boolean;
};

export function HeaderButton({
  children,
  tooltipTitle,
  disableBackground = false,
  ...forwardingProps
}: HeaderButtonProps) {
  const theme = useTheme();

  return (
    <Tooltip title={<div style={{ fontSize: '15px' }}>{tooltipTitle}</div>}>
      <ActionButton
        {...forwardingProps}
        color={theme.header.buttonsColor}
        backgroundColor={
          !disableBackground ? theme.header.buttonsBackgroundColor : undefined
        }
        backgroundHoverColor={theme.header.buttonsBackgroundColor}
      >
        {children}
      </ActionButton>
    </Tooltip>
  );
}

const ActionButton = styled(IconButton)`
  ${({ theme, backgroundHoverColor }) => css`
    border-radius: 50%;

    &:not(:last-child) {
      margin-right: 4px;
    }

    &:focus-visible {
      outline: 3px solid ${theme.header.buttonsOutlineColor};
      outline-offset: 2px;
      background-color: ${backgroundHoverColor};
    }
  `}
`;
